import Vue from 'vue'
import Router from 'vue-router'

import SdUserInfo from '@/components/shenduUserInfo/SdUserInfo'
import SdUserMsg from '@/components/shenduUserInfo/SdMsg'
import SdLogin from '../components/shenduLogin/SdLogin'
import SdRegister from '../components/shenduLogin/SdRegister'
import SdHealthFile from '../components/shenduUserInfo/SdHealthFile'
import SdConcatUs from '../components/shenduUserInfo/SdConcatUs'
import SdGetInvoice from '../components/shenduUserInfo/SdGetInvoice'
import SdGroupDetail from '../components/shenduGroupDetail/SdGroupDetail.vue'
import SdEditInfo from '@/components/shenduUserInfo/SdEditInfo'

import SdAddFile from '../components/shenduUserInfo/SdAddFile'
import SdEditFile from '../components/shenduUserInfo/SdEditFile'

import SdAskOrder from '../components/shenduAskDoctor/SdAskOrder.vue'
import SdLikeDoctor from '@/components/shenduUserInfo/SdLikeDoctor.vue'

import SdSeeDoctor from '../components/shenduSeeDoctor/SdSeeDoctor'
import SdSeeNav from '../components/shenduSeeDoctor/SdSeeNav'
import SdSeeGroup from '../components/shenduSeeDoctor/SdSeeGroup'

import SdGoRegist from '@/components/shenduUserInfo/SdGoRegist'

// import Croppa from '@/components/public/Upavatar.vue'
const Croppa = r => require.ensure([], () => r(require('../components/public/Upavatar')), 'Croppa')

// 按需加载
const SdRichTxt = r => require.ensure([], () => r(require('../components/shenduGroupDetail/SdRichTxt')), 'SdRichTxt')

import SdDetailVideo from '../components/shenduDetailVideo/SdDetailVideo'
import SdDetailVideoSimple from '../components/shenduDetailVideo/SdDetailVideoSimple'
import SdDouyin from '../components/shenduDetailVideo/SdDouyin'

import SdSearch from '../components/shenduSearch/SdSearch'
import SdInquiry from '../components/public/SdInquiry'
import SdDoctorMsg from '../components/shenduAskDoctor/SdDoctorMsg.vue' // SdAskChat
import SdAskChat from '../components/shenduAskDoctor/SdAskChat' // SdAskChat
import VideoTest from '../components/VideoTest'
const SdAskDoctor = r => require.ensure([], () => r(require('../components/shenduAskDoctor/SdAskDoctor')), 'SdAskDoctor')
const SdVideoHistory = r => require.ensure([], () => r(require('../components/shenduUserInfo/SdVideoHistory')), 'SdVideoHistory')
const SdVideoCollect = r => require.ensure([], () => r(require('../components/shenduUserInfo/SdVideoCollect')), 'SdVideoCollect')
const joinUs = r => require.ensure([], () => r(require('../views/cooperation/index')), 'joinUs')
const aboutus = r => require.ensure([], () => r(require('../views/cooperation/aboutus')), 'aboutus')
const cooperation = r => require.ensure([], () => r(require('../views/cooperation/cooperation')), 'cooperation')
const contactUs = r => require.ensure([], () => r(require('../views/cooperation/contactUs')), 'contactUs')
const payCheck = r => require.ensure([], () => r(require('../views/payCheck/payCheck')), 'payCheck')
const demo = r => require.ensure([], () => r(require('../views/demo/demo')), 'demo')
const hasBuyHistory = r => require.ensure([], () => r(require('../components/shenduUserInfo/hasBuyHistory')), 'hasBuyHistory')
const promoteVideo = r => require.ensure([], () => r(require('../views/promote/videoPay')), 'promoteVideo')
const promoteInstance = r => require.ensure([], () => r(require('../views/promote/instance')), 'promoteInstance')

const verifyPhone = r => require.ensure([], () => r(require('../views/doctorRecruit/verifyPhone')), 'doctorRecruit')
const doctorForm = r => require.ensure([], () => r(require('../views/doctorRecruit/doctorForm')), 'doctorRecruit')
const identityCard = r => require.ensure([], () => r(require('../views/doctorRecruit/identityCard')), 'doctorRecruit')
const selectGroup = r => require.ensure([], () => r(require('../views/doctorRecruit/selectGroup')), 'doctorRecruit')
const protocol = r => require.ensure([], () => r(require('../views/doctorRecruit/protocol')), 'doctorRecruit')
const verifyStatus = r => require.ensure([], () => r(require('../views/doctorRecruit/verifyStatus')), 'doctorRecruit')

// 华泰保险
const ehuatai = r => require.ensure([], () => r(require('../views/renbao/renbao')), 'ehuatai')

Vue.use(Router)

export default new Router({
  // mode: 'history',
  mode: 'hash',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/demo',
      name: 'demo' ,
      component: demo
    },
    {
      path: '/hasBuyHistory' ,
      name: "hasBuyHistory",
      component: hasBuyHistory,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/',
      redirect: '/SdSeeDoctor'
    },
    {
      path: '/VideoTest',
      name: 'VideoTest',
      component: VideoTest
    },
    {
      path: '/SdLogin',
      name: 'SdLogin',
      component: SdLogin
    },
    {
      path: '/SdRegister',
      name: 'SdRegister',
      component: SdRegister
    },
    {
      path: '/SdUserInfo',
      name: 'SdUserInfo',
      component: SdUserInfo,
    },
    {
      path: '/goRegist',
      name: 'goRegist',
      component: SdGoRegist,
      meta: {
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/SdUserMsg',
      name: 'SdUserMsg',
      component: SdUserMsg,
      meta: {
        title: '',
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/SdVideoCollect',
      name: 'SdVideoCollect',
      component: SdVideoCollect,
      meta: {
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/SdVideoHistory',
      name: 'SdVideoHistory',
      component: SdVideoHistory,
      meta: {
        title: '',
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/SdHealthFile',
      name: 'SdHealthFile',
      component: SdHealthFile,
      meta: {
        title: '',
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/SdConcatUs',
      name: 'SdConcatUs',
      component: SdConcatUs,
      meta: {
        title: '',
       // requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    // SdGetInvoice
    {
      path: '/SdGetInvoice',
      name: 'SdGetInvoice',
      component: SdGetInvoice,
    },
    {
      path: '/SdAddFile',
      name: 'SdAddFile',
      component: SdAddFile,
      meta: {
        title: '',
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/SdEditFile',
      name: 'SdEditFile',
      component: SdEditFile,
      meta: {
        title: '',
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/SdAskDoctor',
      name: 'SdAskDoctor',
      component: SdAskDoctor,
      meta: {
        title: '',
        keepAlive: false
        // requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/SdAskChat',
      name: 'SdAskChat',
      component: SdAskChat,
      meta: {
        title: '',
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/SdAskOrder',
      name: 'SdAskOrder',
      component: SdAskOrder,
      meta: {
        title: '',
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }

    },
    {
      path: '/SdLikeDoctor',
      name: 'SdLikeDoctor',
      component: SdLikeDoctor,
      meta: {
        title: '',
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/SdDoctorMsg',
      name: 'SdDoctorMsg',
      component: SdDoctorMsg
    },
    // {
    //   path: '/SdVideoBox',
    //   name: 'SdVideoBox',
    //   component: SdVideoBox
    // },
    {
      path: '/SdSeeDoctor',
      name: 'SdSeeDoctor',
      component: SdSeeDoctor,
      meta: {
        keepAlive: true ,
        isNoAbsolute : true
      }
    }, // SdDetailVideo SdSearch
    {
      path: '/SdSeeNav',
      name: 'SdSeeNav',
      component: SdSeeNav
    },
    {
      path: '/SdSeeGroup',
      name: 'SdSeeGroup',
      component: SdSeeGroup
    },
    {
      path: '/SdGroupDetail',
      name: 'SdGroupDetail',
      component: SdGroupDetail,
      meta: {
        isNoAbsolute: true,
        keepAlive: true
      }
    },
    {
      path: '/SdEditInfo',
      name: 'SdEditInfo',
      component: SdEditInfo,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/SdRichTxt',
      name: 'SdRichTxt',
      component: SdRichTxt,
      meta: {
        isNoAbsolute: true,
        keepAlive: true
      }
    },
    {
      path: '/SdDetailVideo',
      name: 'SdDetailVideo',
      component: SdDetailVideo ,
      meta: {
        isNoAbsolute : true
      }
    },
    {
      path: '/SdDouyin',
      name: 'SdDouyin',
      component: SdDouyin,
      meta: {
        isNoAbsolute: true
      }
    },
    {
      // 不带相关医生
      path: '/SdDetailVideoSimple',
      name: 'SdDetailVideo2',
      component: SdDetailVideoSimple,
      meta: {
        isNoAbsolute : true
      }
    },
    {
      path: '/SdSearch',
      name: 'SdSearch',
      component: SdSearch,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/SdInquiry',
      name: 'SdInquiry',
      component: SdInquiry,
      meta: {
        title: '',
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/payCheck/:orderId/:orderType', // orderType : doctor（问诊） video （点播）
      name: 'payCheck',
      component: payCheck,
      meta: {
        title: '',
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/joinUs' ,
      name: 'joinUs' ,
      component : joinUs
    },
    {
      path: '/aboutus' ,
      name: 'aboutus' ,
      component : aboutus
    },
    {
      path: '/contactUs' ,
      name: 'contactUs' ,
      component : contactUs
    },

    {
      path: '/cooperation' ,
      name: 'cooperation' ,
      component : cooperation
    },
    {
      path: '/promoteVideo',
      name: 'promoteVideo',
      component : promoteVideo
    },
    {
      path: '/promoteInstance',
      name: 'promoteInstance',
      component : promoteInstance
    },
    // 医生招募模块 ↓
    {
      path: '/doctorForm',
      name: 'doctorForm',
      component: doctorForm,
      meta: {
        isNoAbsolute: true
      }
    },
    {
      path: '/identityCard',
      name: 'identityCard',
      component: identityCard,
      meta: {
        isNoAbsolute: true
      }
    },
    {
      path: '/protocol',
      name: 'protocol',
      component: protocol,
      meta: {
        isNoAbsolute: true
      }
    },
    {
      path: '/selectGroup',
      name: 'selectGroup',
      component: selectGroup,
      meta: {
        isNoAbsolute: true
      }
    },
    {
      path: '/verifyPhone',
      name: 'verifyPhone',
      component: verifyPhone,
      meta: {
        isNoAbsolute: true
      }
    },
    {
      path: '/verifyStatus',
      name: 'verifyStatus',
      component: verifyStatus,
      meta: {
        isNoAbsolute: true
      }
    },
    {
      path: '/croppa',
      name: 'croppa',
      component: Croppa,
      meta: {
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    // 医生招募模块 ↑
    // 保险模块↓
    {
      path: '/ehuatai',
      name: 'ehuatai',
      component: ehuatai,
    },
    // 保险模块↑
    {
      path: '*',
      redirect: '/SdSeeDoctor'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js